import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Dynamictemplate from "../../component/course/dynamic365";
 export default class Dynamicinmadurai extends Component {
 
  render() {
      
    const title = "Dynamic365" 
    const url ="dynamic365"  
     const url1 ="-training-in-madurai"
    const location = "madurai" 
    const location1="Training in Madurai"
     return(
      <>
          <NextSeoModule
            title={`${title} ${location1} - learnsoft.org`}
            description={`Learn Dynamics 365 from Learnsoft, a leading training institute in ${location}. Our Dynamics 365 training program is designed to help you become proficient in Microsoft's cloud-based enterprise resource planning (ERP) and customer relationship management (CRM) software. Our experienced trainers provide practical training and real-world projects to help you gain hands-on experience. Enroll now and become a certified Dynamics 365 professional to accelerate your career growth in enterprise software development.`}
            url={`${location}/${url}${url1}`}
           img={`course/${url}.webp`}
             keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Dynamictemplate url1={url1} title={title} url={url} relatedlocation={location} location={location} location1={location1} />
         </Layout>
      </>
    );
  }
}
